var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g2, _path35, _g3, _path36, _path37, _path38;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20450_1926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 8,
    width: 94,
    height: 105
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.25H106.687V112.4H13.5V8.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20450_1926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.723 42.5514L46.7402 8.44041C46.4721 8.28498 46.2167 8.25484 46.0518 8.3738C44.9621 9.15892 43.7059 10.1185 43.7059 10.1185H43.7075L43.7028 10.1217C43.5315 10.2232 43.4252 10.4357 43.4236 10.7355L43.2935 56.6947C43.2935 56.8184 43.3157 56.9469 43.3475 57.077L13.8997 74.3022C13.6364 74.4544 13.5063 74.6559 13.5063 74.8573V74.8541L13.5 77.062C13.5 77.265 13.6332 77.4696 13.9013 77.6251L72.1925 112.083C72.7239 112.389 73.5883 112.389 74.1149 112.083L106.118 93.3625C106.38 93.2102 106.511 93.0104 106.511 92.8089L106.518 90.7137C106.533 90.6407 106.546 90.563 106.546 90.4726L106.684 44.2184C106.686 43.6077 106.253 42.8591 105.723 42.5514Z",
    fill: "#6183E4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8672 65.1153L41.6014 67.017L38.3149 65.1153L41.5792 63.2151L44.8672 65.1153Z",
    fill: "#F1F5F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2859 67.672L46.0201 69.5722L42.7305 67.6704L45.9963 65.7687L49.2859 67.672Z",
    fill: "#F1F5F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.257 68.6078L38.0753 70.4604L34.8745 68.6094L38.0563 66.7568L41.257 68.6078Z",
    fill: "#F1F5F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2888 70.6539L32.0214 72.5557L28.7334 70.6539L32.0008 68.7522L35.2888 70.6539Z",
    fill: "#F1F5F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5428 71.0871L42.3611 72.9381L39.1587 71.0871L42.3404 69.2345L45.5428 71.0871Z",
    fill: "#F1F5F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1223 72.7809L54.8565 74.6826L51.5669 72.7809L54.8327 70.8792L58.1223 72.7809Z",
    fill: "#F1F5F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7184 73.2156L36.451 75.1189L33.1646 73.2172L36.4319 71.3154L39.7184 73.2156Z",
    fill: "#F1F5F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.828 73.5645L46.6462 75.4171L43.4438 73.5645L46.6256 71.7135L49.828 73.5645Z",
    fill: "#F1F5F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5377 75.3362L59.2735 77.2364L55.9839 75.3346L59.2497 73.4344L62.5377 75.3362Z",
    fill: "#F1F5F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1498 75.7787L40.8824 77.6805L37.5928 75.7787L40.8618 73.877L44.1498 75.7787Z",
    fill: "#F1F5F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1114 76.0419L50.9297 77.8945L47.7305 76.0435L50.9106 74.1909L54.1114 76.0419Z",
    fill: "#F1F5F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9571 77.8914L63.6929 79.7931L60.4033 77.8914L63.6691 75.9896L66.9571 77.8914Z",
    fill: "#F1F5F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5799 78.3402L45.3125 80.2436L42.0229 78.3402L45.2919 76.4385L48.5799 78.3402Z",
    fill: "#F1F5F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3968 78.5212L55.2151 80.3722L52.0127 78.5212L55.1944 76.6686L58.3968 78.5212Z",
    fill: "#F1F5F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3741 80.4451L68.1083 82.3468L64.8203 80.4451L68.0861 78.5449L71.3741 80.4451Z",
    fill: "#F1F5F9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.682 80.9986L59.5002 82.8512L56.2979 80.9986L59.4796 79.146L62.682 80.9986Z",
    fill: "#F1F5F9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7931 83.0018L72.5289 84.9036L69.2393 83.0003L72.5051 81.1001L75.7931 83.0018Z",
    fill: "#F1F5F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9647 83.4761L63.7845 85.3287L60.5806 83.4761L63.7623 81.6235L66.9647 83.4761Z",
    fill: "#F1F5F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2498 85.9535L68.0681 87.8061L64.8657 85.9535L68.0475 84.101L71.2498 85.9535Z",
    fill: "#F1F5F9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6279 88.1107L81.3621 90.0109L78.0757 88.1107L81.3399 86.209L84.6279 88.1107Z",
    fill: "#F1F5F9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5364 88.4328L72.3547 90.2838L69.1523 88.4328L72.3341 86.5802L75.5364 88.4328Z",
    fill: "#F1F5F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2751 90.309L66.0077 92.2107L46.4922 80.9256L49.7596 79.0222L69.2751 90.309Z",
    fill: "#F1F5F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.047 90.6659L85.7812 92.5677L82.4932 90.6643L85.7574 88.7642L89.047 90.6659Z",
    fill: "#F1F5F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8184 90.9086L76.6367 92.7612L73.4375 90.9102L76.6192 89.0592L79.8184 90.9086Z",
    fill: "#F1F5F9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4625 93.2212L90.1983 95.1214L86.9087 93.2196L90.1745 91.3179L93.4625 93.2212Z",
    fill: "#F1F5F9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1344 93.6987L71.8686 95.6004L67.5005 93.0737L70.7679 91.1736L75.1344 93.6987Z",
    fill: "#F1F5F9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6422 96.0271L85.4605 97.8796L77.8027 93.4496L80.9845 91.5986L88.6422 96.0271Z",
    fill: "#F1F5F9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5008 96.2222L76.2319 98.1255L72.9438 96.2238L76.2112 94.3204L79.5008 96.2222Z",
    fill: "#F1F5F9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8866 98.7599L80.6192 100.662L77.3296 98.7599L80.5986 96.8582L83.8866 98.7599Z",
    fill: "#F1F5F9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7036 70.2257L50.4378 72.1275L47.1514 70.2257L50.4156 68.3256L53.7036 70.2257Z",
    fill: "#F1F5F9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2106 85.5554L76.9447 87.4572L73.6567 85.5554L76.9225 83.6537L80.2106 85.5554Z",
    fill: "#F1F5F9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4326 92.3298L55.4831 95.7938L37.2349 85.2414L43.1844 81.7773L61.4326 92.3298Z",
    fill: "#F1F5F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20450_1926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 74,
    width: 94,
    height: 39
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 74.6986H106.687V112.401H13.5V74.6986Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20450_1926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.123 91.1562L74.1212 109.875C73.5946 110.183 72.7302 110.183 72.2004 109.875L13.9076 75.4188C13.6396 75.2633 13.5048 75.0587 13.5063 74.8541L13.5 77.062C13.5 77.265 13.6332 77.4696 13.9013 77.6251L72.1925 112.083C72.7239 112.389 73.5883 112.389 74.1149 112.083L106.118 93.3625C106.38 93.2102 106.511 93.0104 106.511 92.8089L106.518 90.6026C106.516 90.8041 106.386 91.0039 106.123 91.1562Z",
    fill: "#1D4ED8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20450_1926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 8,
    width: 64,
    height: 85
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1382 8.25H106.687V92.9706H43.1382V8.25Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20450_1926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.723 42.5514L46.7401 8.44041C46.472 8.28498 46.2167 8.25484 46.0517 8.3738C44.9621 9.15892 43.7059 10.1185 43.7059 10.1185H43.7074C43.533 10.2184 43.4251 10.4326 43.4235 10.7355L43.2935 56.6947C43.2919 57.307 43.7249 58.0556 44.2578 58.3633L103.241 92.4758C103.545 92.6519 103.815 92.6408 103.992 92.4869L103.926 92.5425L106.265 91.0912C106.438 90.9897 106.546 90.7771 106.546 90.4726L106.684 44.2184C106.686 43.6077 106.253 42.8591 105.723 42.5514Z",
    fill: "#6183E4"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M103.377 44.2976C103.907 44.6037 104.34 45.3539 104.338 45.9646L104.208 91.9238C104.207 92.5344 103.772 92.7835 103.241 92.4758L44.2578 58.3632C43.7249 58.0555 43.2919 57.3069 43.2935 56.6946L43.4235 10.7354C43.4267 10.1248 43.8613 9.87736 44.3926 10.1851L103.377 44.2976Z",
    fill: "#173EAD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4615 13.5651L45.3457 54.2377L102.178 87.1036L102.293 46.4325L45.4615 13.5651Z",
    fill: "#F1F5F9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M102.293 46.4325L45.3457 54.2377L45.4615 13.5651L102.293 46.4325Z",
    fill: "#F1F5F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.e0b472b153cf9e8023abcbf3566a6b78.svg";
export { ForwardRef as ReactComponent };